import React from 'react'
import { ListImageBoxItem as OriginalListImageBoxItem } from '@next-nx/shared-ui/molecules'
import { ListImageBoxItemSettings } from './ListImageBoxItemSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { useEditor } from '@craftjs/core'

export const defaultProps = {
  icon: null
}

export const ListImageBoxItem = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    };

    const { icon } = blockProps

    const { children } = props
    
    const { enabled } = useEditor((state) => ({
      enabled: state.options.enabled,
    }));

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={'block-list-image-box-item ' + props.className}
      >
        <OriginalListImageBoxItem
          item={{
            name: children.props.children[0],
            description: children.props.children[1],
            style: icon
          }}
          editMode={enabled}
        />
      </div>
    );
  },
  defaultProps
);

ListImageBoxItem.craft = withCraft({
  name: 'ListImageBoxItem',
  defaultProps: defaultProps,
  settings: ListImageBoxItemSettings,
});
